export default "__VITE_ASSET__747d05b8__"